module.exports = __webpack_public_path__ + "static/media/LR logo.4fbef8fa.png";